import { CommonUtilities }  from '../../commonUtils';

export default class UserServices{

    //https://staging2.onkorrect.com/Api/catalogue/projectContact/listMyTeam?projectId=50434&pageNumber=1&pageSize=10&
    static UserListing(data: any){
        var url = 'catalogue/projectContact/listMyTeam?' + data;    
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/contacts/contactArtist?contactNameOrCode=&digitalOnly=&projectId=10088&pageNumber=1&pageSize=10
    static contactArtist (data: any){ 
        var url = 'contacts/contactArtist?contactNameOrCode='+data ; 
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/catalogue/projectContact/delete/10031
    static contactRemove (data: any){ 
        var url = 'catalogue/projectContact/delete/'+data ;
        return CommonUtilities.deleteData("");
    }

    /** */

    //https://qa.onkorrect.com/Api/MusicDirectory/categories/list?type=creators
    static MusicDirectory (data: any){
        var url = 'MusicDirectory/categories/list?type=creators' ;     
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/musicDirectory/musicCreatorCategory/list
    static MusicCreatorCategory (data: any){
        var url = 'musicDirectory/musicCreatorCategory/list' ;     
        return CommonUtilities.getData(url);
    }

   // https://qa.onkorrect.com/Api/metadata/label?companyName=&orderBy=CompanyName&sortBy=ASC
   static label (data: any){
        var url = 'metadata/label?companyName=&orderBy=CompanyName&sortBy=ASC' ;     
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/contracts/systemFormats?isPartFormatListed=true
    static systemFormats (data: any){
        var url = 'contracts/systemFormats?isPartFormatListed=true' ;      
        return CommonUtilities.getData(url);
    }

   // https://qa.onkorrect.com/Api/common/statusProduct/list?pageNumber=1&pageSize=10
   static statusProduct (data: any){
        var url = 'common/statusProduct/list?pageNumber=1&pageSize=10' ;
        return CommonUtilities.getData(url);
    }

   //https://qa.onkorrect.com/Api/common/statusProductExt/list?pageNumber=1&pageSize=10
   static statusProductExt (data: any){
        var url = 'common/statusProductExt/list?pageNumber=1&pageSize=10' ;    
        return CommonUtilities.getData(url);
    }

    //https://qa.onkorrect.com/Api/catalogue/projectContact/save
    static moveToTeam(data:any ){
        var url = 'catalogue/projectContact/save';
        return CommonUtilities.postData(url, data);
    }

}